import { getTrpcErrorCode, getTrpcErrorMessage } from "@/shared/utils/trpc/handletrpcError.util";

export const INTENT_QUESTIONNAIRE_SKIP_KEY = "gt:intentQuestionnaire:skipUntil";

export function clearIntentQuestionnaireSkip() {
  sessionStorage.removeItem(INTENT_QUESTIONNAIRE_SKIP_KEY);
}

export function isIntentQuestionnaireSkippedInSession(): boolean {
  try {
    return sessionStorage.getItem(INTENT_QUESTIONNAIRE_SKIP_KEY) === "1";
  } catch {
    return false;
  }
}

export function markIntentQuestionnaireSkippedInSession() {
  try {
    sessionStorage.setItem(INTENT_QUESTIONNAIRE_SKIP_KEY, "1");
  } catch {
    /* ignore quota / private mode */
  }
}

export function isCompanyIntentIncompleteError(error: unknown): boolean {
  const code = getTrpcErrorCode(error);
  const message = getTrpcErrorMessage(error).toLowerCase();
  return (
    code === "PRECONDITION_FAILED" &&
    (message.includes("company intent questionnaire") || message.includes("intent questionnaire"))
  );
}
